module.exports = __webpack_public_path__ + "img/1.cb0f5f4c.png";